// CDK backend configuration
// This file contains endpoints and configuration for CDK-deployed resources

const cdkConfig = {
  // Region should match your CDK deployment
  region: 'us-west-2',
  
  // S3 bucket information (from your CDK deployment)
  storage: {
    bucket: 'captioncorner4e47ea7b4ff349cfafe46a5ac220c561', // Using the same bucket name as imported in CDK
    region: 'us-west-2'
  },
  
  // Lambda function information (from your CDK deployment)
  lambda: {
    s3TriggerFunction: {
      name: 'CdkAppStack-LambdaStackS3TriggerFunction',
    },
    transcribeCompleteFunction: {
      name: 'CdkAppStack-LambdaStackTranscribeCompleteFunction',
    },
    processFeedbackFunction: {
      name: 'CdkAppStack-LambdaStackProcessFeedbackFunction',
    }
  },
  
  // Analytics API configuration (from CDK deployment)
  analytics: {
    apiUrl: 'https://m4mhwezngbd27bu5iairmvmz4a.appsync-api.us-west-2.amazonaws.com/graphql',
    apiId: 'gjfixkwrsngfnmgb34s3222yxy',
    region: 'us-west-2'
  },
  
  // Feature flags to control which backend to use
  features: {
    useS3CDK: false,      // Use CDK S3 for storage - DISABLED due to permission issues
    useLambdaCDK: false,  // Use CDK Lambda functions directly (not implemented yet)
    useAppsyncCDK: true,  // Use CDK AppSync for analytics
    useAuthCDK: false     // Use CDK Auth (not implemented yet)
  }
};

export default cdkConfig;
